import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import DirectoryTable from "@/components/DirectoryTable";
import { useAuth } from "@/context/AuthContext";
import { hasRole } from "@/lib/utils";

// Skills is a flat admin-managed catalog with an optional parent for a lightweight
// two-level tree (category -> skill). It's the single taxonomy shared by Step 1's
// client technology checkboxes and Step 2's faculty skill mapping.
export default function AdminSkills() {
  const { user } = useAuth();
  const [skills, setSkills] = useState([]);

  useEffect(() => { api.get("/skills").then(({ data }) => setSkills(data)).catch(() => {}); }, []);

  const FIELDS = [
    { name: "name", label: "Skill / Technology Name", required: true },
    { name: "parent_id", label: "Parent Category (optional)", type: "select", options: skills.map((s) => ({ value: s.id, label: s.name })) },
  ];

  const COLUMNS = [
    { key: "name", label: "Skill / Technology" },
    { key: "parent_id", label: "Parent Category", render: (it) => skills.find((s) => s.id === it.parent_id)?.name || "-" },
  ];

  return (
    <DirectoryTable
      title="Skills"
      description="Shared skills/technology taxonomy used for client requirements (Step 1) and faculty skill mapping (Step 2)."
      endpoint="/skills"
      columns={COLUMNS}
      fields={FIELDS}
      canWrite={hasRole(user)}
    />
  );
}
